import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id D4BAB490-2216-4AE7-8DBC-26F4B2F5F9AC
 * name pocket
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pocket.svg
 * tags
 */
export const PocketIcon = createSvgIcon(<><path d="M4 3H20V17.63L12 22.25L4 17.63V3M18 9H6V16.5L12 19.94L18 16.5V9M18 5H6V7H18V5Z" /></>, 'PocketIcon');
export default PocketIcon